<script setup lang="ts">
import { useAuthStore } from "~/stores/auth/store";
import TrainingCommonView from "~/components/Training/TrainingCommonView.vue";
import { ProductTypes } from "~/types";
import TrainingUserView from "~/components/Training/TrainingUserView.vue";

definePageMeta({
  layout: "training",
});

useSeoMeta({
  title: "Training | PokerGO",
  ogTitle: "Training | PokerGO",
  twitterTitle: "Training | PokerGO",
});

const authStore = useAuthStore();
</script>

<template>
  <div>
    <div class="h-20"></div>
    <div class="m-auto max-w-screen-lg px-4 py-5 lg:px-5 lg:py-10">
      <TrainingUserView
        v-if="authStore.subscription.interval === ProductTypes.TRAINING_ANNUAL"
      />
      <TrainingCommonView v-else />
    </div>
  </div>
</template>

<style scoped></style>
